import { isEmpty, isNil } from 'lodash';
import { PageStructure } from 'src/components/SideBar/sidebar-types';

export function getMatch(path: string, pageStructures: PageStructure[]): string | undefined {
    if (isEmpty(path) || path === '/') {
        return undefined;
    }

    return pageStructures
        .flatMap((ps) =>
            ps.flatMap((topLevel) => {
                const links = [];
                if (!isNil(topLevel.href)) {
                    links.push(topLevel.href);
                }
                topLevel.children?.forEach((child) => links.push(child.href));
                return links;
            })
        )
        .sort()
        .reverse()
        .find((link) => path.startsWith(link));
}
